export const formatDuration = seconds => {
  if (!seconds) return '--'
  return `${Math.floor(seconds / 60)}:${(seconds % 60)
    .toString()
    .padStart(2, '0')}`
}

export const formatCallTimestamp = seconds => {
  if (seconds === null || seconds === undefined) return ''
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

export const getEstadoRespuestaLlamada = llamada => {
  const motivo =
    llamada?.motivoLlamadaPerdida ?? llamada?.motivo_llamada_perdida
  return motivo && motivo !== 'null' ? 'PERDIDA' : 'RESPONDIDA'
}
